var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M47.46 39.334c1.538 2.667-.393 6-3.465 6H4.005c-3.079 0-5-3.339-3.465-6L20.535 4.665c1.54-2.667 5.394-2.662 6.93 0l19.995 34.67zM24 32.167a3.833 3.833 0 1 0 0 7.666 3.833 3.833 0 0 0 0-7.666zm-3.64-13.78l.619 11.334a1 1 0 0 0 .998.946h4.046a1 1 0 0 0 .998-.946l.618-11.333a1 1 0 0 0-.998-1.055h-5.282a1 1 0 0 0-.998 1.055z"
  })));
};
export default SvgReport;